import * as React from "react"
import {AutocompleteAsyncSeeker} from "@ui-seeker/core"

import {BACKEND_APIS} from "@constants"
import {brand} from "../@signals"


export default function UnmatchedNewProductsBrandAutocomplete({ ...props }) {
    return <AutocompleteAsyncSeeker
        multiple
        urlAjax={`${BACKEND_APIS.UNMATCHED}/new-products/brand`}
        label="Brands"
        placeholder="Search Brand..."
        value={brand.value}
        onChange={e => brand.value = e.target.value}
        {...props}
    />
}